import { DOTS } from '@components/constants';
import { useMemo } from 'react';
import { UsePaginationLoaderProps } from './usePaginationLoader.types';

const range = (start: number, end: number): number[] => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const usePaginationLoader = (props: UsePaginationLoaderProps): Array<string | number> | undefined => {
  const { pageSize, currentPage, hasMorePages } = props;

  const FIRST_PAGE_INDEX = 1;
  const PAGE_NUMBERS: number = 4;
  const RANGE_START: number = 1;
  const SIBLING_SPACES: number = 2;
  const DOTS_SPACES: number = 3;
  const siblingCount = 1;

  const paginationRange = useMemo(() => {
    const totalPageCount = hasMorePages ? currentPage + 1 : currentPage;
    const totalVisiblePages = siblingCount + PAGE_NUMBERS;

    const lastPages = hasMorePages ? [DOTS] : [];

    // Displaying pages in the range from 1 to totalVisiblePages
    if (totalVisiblePages >= totalPageCount) {
      return [...range(RANGE_START, totalPageCount), ...lastPages];
    }
    const rightItemCount = DOTS_SPACES + SIBLING_SPACES * siblingCount;
    const rightRange = range(totalPageCount - rightItemCount + RANGE_START, totalPageCount);
    return [FIRST_PAGE_INDEX, DOTS, ...rightRange, ...lastPages];
  }, [pageSize, siblingCount, currentPage]);

  return paginationRange;
};
